import { reactive } from 'vue';

export const criarManifDepartamento = () => {
    return reactive({
        id: 0,
        idmunicipio: 0,
        cddepartamento: 0,
        nmdepartamento: '',
        detalhamento: '',
        ativo: 'S',
        idlogin: 0
    });
};